import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IGroup } from "@defs/group";

interface GroupsState {
  data: IGroup[];
  compleateList: IGroup[];
  loading: boolean;
}

const initialState: GroupsState = {
  loading: true,
  data: [],
  compleateList: [],
};

const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    reset(state) {
      state.loading = true;
      state.data = [];
      state.compleateList = [];
    },
  },
  extraReducers: {
    "groups/list/pending": (state) => {
      state.loading = initialState.loading;
      state.data = initialState.data;
    },
    "groups/list/fulfilled": (state, action: PayloadAction<IGroup[]>) => {
      state.loading = false;
      state.data = action.payload;
    },
    "groups/list/with-hidden/pending": (state) => {
      state.loading = initialState.loading;
      state.compleateList = initialState.data;
    },
    "groups/list/with-hidden/fulfilled": (
      state,
      action: PayloadAction<IGroup[]>
    ) => {
      state.loading = false;
      state.compleateList = action.payload;
    },
  },
});

export const groupsActions = groupsSlice.actions;

export default groupsSlice.reducer;
